import { GET_LEAD } from './getLead';
import { GET_ACCOUNT_LEAD_OPTIONS } from './getLeadOptions';
import { GET_PARTNER_LINKS_OPTIONS } from './getPartnerLinksOptions';
import { CREATE_LEAD_PROPOSAL } from './createLeadProposal';
import { GET_DEALER_LOCATIONS_OPTIONS } from './getDealerLocationsOptions';

export const startDealApi = {
  getLead: GET_LEAD,
  createLeadProposal: CREATE_LEAD_PROPOSAL,
  getAccountLeadOptions: GET_ACCOUNT_LEAD_OPTIONS,
  getPartnerLinksOptions: GET_PARTNER_LINKS_OPTIONS,
  getDealerLocationsOptions: GET_DEALER_LOCATIONS_OPTIONS,
};
